var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class DunningLetterResponseDto {
    /** Aggregate id of the produced `DunningLetter`. */
    id;
    documentId;
    identity;
    invoiceId;
    dunningFeeCents;
    totalDueCents;
    newDueDate;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningLetterResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningLetterResponseDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningLetterResponseDto.prototype, "identity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningLetterResponseDto.prototype, "invoiceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningLetterResponseDto.prototype, "dunningFeeCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningLetterResponseDto.prototype, "totalDueCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningLetterResponseDto.prototype, "newDueDate", void 0);
//# sourceMappingURL=dunning-letter.response.dto.js.map